import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Store } from './store';
import List from './List';
import ReplyModal from './ReplyModal';

const Comments = ({ subjectId }) => {
    return (
        <Store.Provider>
            <List subjectId={subjectId} />
            <ReplyModal />
        </Store.Provider>
    );
};

Comments.propTypes = {
    subjectId: PropTypes.string,
};

export default errorBoundary(Comments);
